import { adminSearchShardCatalogDetailsDefaultGetSlice } from './get';

export const {
	requestGetAdminSearchShardCatalogDetailsDefault,
	resetGetAdminSearchShardCatalogDetailsDefault
} = adminSearchShardCatalogDetailsDefaultGetSlice.asyncActionCreators;
